import React, { Fragment } from "react";
import { PropTypes } from "prop-types";
import HtmlTooltip from "./HtmlTooltip";

export default function CustomerTaxStatus({ type }) {
  return (
    <HtmlTooltip
      type={type}
      title={
        <Fragment>
          <p>
            <b>Customer tax status</b>
          </p>
          <p>
            This object is structured as follows:
            <pre>
              <code>
                {`
{
  "taxable": boolean,
  "taxCode": {
    "id": integer,
    "name": string
  }
}`}
              </code>
            </pre>
          </p>
          <p>
            When creating or updating a transaction, only the id is required for
            the taxCode.
          </p>
        </Fragment>
      }
    ></HtmlTooltip>
  );
}
CustomerTaxStatus.propTypes = {
  type: PropTypes.string.isRequired
};
